/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventValidatorResponse
 */
export interface EventValidatorResponse {
    /**
     * The ID of the event type this mapping is associated with
     * @type {string}
     * @memberof EventValidatorResponse
     */
    eventTypeId: string;
    /**
     * JSON Logic conditions to evaluate against the event's own fields
     * @type {object}
     * @memberof EventValidatorResponse
     */
    jsonValidator?: object;
    /**
     * JSON Logic conditions to evaluate against user's current state (game mode, map, etc.)
     * @type {object}
     * @memberof EventValidatorResponse
     */
    contextValidator?: object;
    /**
     * 
     * @type {string}
     * @memberof EventValidatorResponse
     */
    photoType?: string;
}

/**
 * Check if a given object implements the EventValidatorResponse interface.
 */
export function instanceOfEventValidatorResponse(value: object): value is EventValidatorResponse {
    if (!('eventTypeId' in value) || value['eventTypeId'] === undefined) return false;
    return true;
}

export function EventValidatorResponseFromJSON(json: any): EventValidatorResponse {
    return EventValidatorResponseFromJSONTyped(json, false);
}

export function EventValidatorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventValidatorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'eventTypeId': json['eventTypeId'],
        'jsonValidator': json['jsonValidator'] == null ? undefined : json['jsonValidator'],
        'contextValidator': json['contextValidator'] == null ? undefined : json['contextValidator'],
        'photoType': json['photoType'] == null ? undefined : json['photoType'],
    };
}

export function EventValidatorResponseToJSON(json: any): EventValidatorResponse {
    return EventValidatorResponseToJSONTyped(json, false);
}

export function EventValidatorResponseToJSONTyped(value?: EventValidatorResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventTypeId': value['eventTypeId'],
        'jsonValidator': value['jsonValidator'],
        'contextValidator': value['contextValidator'],
        'photoType': value['photoType'],
    };
}

